export enum KanbanStatus {
    WAITING = 'WAITING',
    ADMITTED = 'ADMITTED',
    VISIT = 'VISIT',
    CONCLUDE = 'CONCLUDE',
}
